import * as React from "react";
import ChevronRight from "~icons/ic/outline-chevron-right";

interface LeftPanelCollapsedProps {
  /**
   * Onclick handler for expanding the left panel
   */
  onClick: () => void;
  /**
   * Flag to expand / collapse
   */
  isCollapsed: boolean;
}

/**
 * Responsible for rendering the left panel collapsed component
 */
const LeftPanelCollapsedView: React.FC<LeftPanelCollapsedProps> = (props: LeftPanelCollapsedProps) => {

  const collapseClass = props.isCollapsed ? "expanded" : "collapsed";

  return (
    <div className={`ebt-leftpanel--shrinked ebt-leftpanel--${collapseClass}`}>
      <div className="expand-collapse-icon__container-expand">
        <ChevronRight className="expand-collapse-icon" title="Expand" onClick={props.onClick} />
      </div>
    </div>
  );
};

export default LeftPanelCollapsedView;
